import { IActionMap } from '@omaze/redux';

import { createFeatureFlagActionType } from './FeatureFlag.factory';

export const FEATURE_FLAG_ACTIONS: IActionMap = {
    ENABLE: createFeatureFlagActionType('enable'),
    DISABLE: createFeatureFlagActionType('disable'),
    REGISTER: createFeatureFlagActionType('register'),
    UNREGISTER: createFeatureFlagActionType('unregister'),
};
